const POLICIES_MOCK = [
  {
    id: 0,
    name: "HR Security Policy",
    framework: ["HIPAA", "FedRAMP", "SOC 2"],
    policy_status: 0,
    renew_by: "2024-07-27",
    document_owner: "Affan Ansari",
    policy_owner: "Saif Mulla",
    last_modified_by: "John Doe - November 30, 2024, 3:45 PM"
  },
  {
    id: 1,
    name: "Code of Conduct",
    framework: ["HIPAA", "FedRAMP", "SOC 2"],
    policy_status: 2,
    renew_by: "2024-07-27",
    document_owner: "Affan Ansari",
    policy_owner: "Saif Mulla",
    last_modified_by: "John Doe - November 30, 2024, 3:45 PM"
  },
  {
    id: 2,
    name: "Third-party management policy",
    framework: ["HIPAA", "FedRAMP", "SOC 2"],
    policy_status: 1,
    renew_by: "2024-07-27",
    document_owner: "Affan Ansari",
    policy_owner: "Saif Mulla",
    last_modified_by: "John Doe - November 30, 2024, 3:45 PM"
  },
  {
    id: 3,
    name: "Risk Management Policy",
    framework: ["HIPAA", "FedRAMP", "SOC 2"],
    policy_status: 0,
    renew_by: "2024-07-27",
    document_owner: "Affan Ansari",
    policy_owner: "Saif Mulla",
    last_modified_by: "John Doe - November 30, 2024, 3:45 PM"
  },
  {
    id: 4,
    name: "Data Management Policy",
    framework: ["HIPAA", "FedRAMP", "SOC 2"],
    policy_status: 0,
    renew_by: "2024-07-27",
    document_owner: "Affan Ansari",
    policy_owner: "Saif Mulla",
    last_modified_by: "John Doe - November 30, 2024, 3:45 PM"
  },
  {
    id: 5,
    name: "Secure Development Policy",
    framework: ["HIPAA", "FedRAMP", "SOC 2"],
    policy_status: 2,
    renew_by: "2024-07-27",
    document_owner: "Affan Ansari",
    policy_owner: "Saif Mulla",
    last_modified_by: "John Doe - November 30, 2024, 3:45 PM"
  },
]

export default POLICIES_MOCK